import React from 'react';
import { Employee } from '..';
import { EmployeeFeedbacks } from './EmployeeFeedbacks';

type Props = {
  employee: Employee;
};

export const EmployeePerformaceReview: React.FC<
  React.PropsWithChildren<Props>
> = ({ employee }) => {
  return <EmployeeFeedbacks employee={employee} />;
};
